// @ts-ignore
 
import request from "src/lib/axios";

/** 查询支付记录 查询当前用户的支付记录 GET /api/v1/app/payment */
export async function AppPaymentControllerQueryPaymentsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppPaymentControllerQueryPaymentsV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    "/api/v1/app/payment",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取支付详情 根据支付 ID 获取支付详情 GET /api/v1/app/payment/${param0} */
export async function AppPaymentControllerGetPaymentByIdV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppPaymentControllerGetPaymentByIdV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputPaymentDto>(
    `/api/v1/app/payment/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
